module.exports = __webpack_public_path__ + "static/media/rca_icon.a712cca8.png";